import script from "./SafetyModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SafetyModal.vue?vue&type=script&setup=true&lang=ts"

import "./SafetyModal.vue?vue&type=style&index=0&id=d058721a&lang=scss"

const __exports__ = script;

export default __exports__